import React, {useEffect, useState} from 'react';
import {useLanguageStore} from "../store/languageStore";
import {api} from "../api/api";
import {Link} from "react-router-dom";

export default function DocumentsPage() {


    const {language} = useLanguageStore()
    const isArabic = language === 'ar'

    const [documents, setDocuments] = useState([]);


    useEffect(() => {
        api.get('documents')
            .then(response => {
                setDocuments(response.data.results);
                console.log("documents fetched successfully!", response.data.results);
            })
            .catch(error => {
                console.error("There was an error fetching the documents!", error);
            });
    }, []);

    // Document data

    // Document card component
    const DocumentCard = ({document}) => (
        <div className="bg-white rounded-md shadow-sm p-6 flex flex-col items-center">
            <div className="w-full h-40 mb-4 flex justify-center">
                <img loading="lazy"
                    src={document.image}
                    alt={document.title_en}
                    className="h-full object-contain"
                />
            </div>
            <h3 className="text-xs font-bold mb-3 text-center">{isArabic ? document.title_ar : document.title_en}</h3>
            <Link to={document.files[0].file} target="_blank" rel="noopener noreferrer">
                <button
                    className="bg-teal-500 hover:bg-teal-600 text-white py-2 px-4 rounded-md text-xs flex items-center gap-2 transition-colors">
                    {isArabic ? "تحميل" : "Download PDF File"}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                         className="ml-1">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                </button>
            </Link>
        </div>
    );

    return (
        <div className="  bg-gray-50 min-h-screen py-12" dir={isArabic ? 'rtl' : 'ltr'}>
            <div className="max-w-7xl mx-auto px-4">
                <h1 className="text-2xl font-bold mb-10" >{isArabic ? "الوثائق" : "Documents"}</h1>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {documents.map(document => (
                        <DocumentCard key={document.id} document={document}/>
                    ))}
                </div>
            </div>
        </div>
    );
}